import { style } from 'typestyle'
import { important } from 'csx'
export const primaryMediumi = style({ color: important('#6599da') })
